import React from "react";
import styled from 'styled-components';
import classnames from "classnames";
import { Loading } from "../loading";

const CardToggleWrapper = styled.div`
  background-color: #EBEBEB;
  border: 0.5px solid #49475B;
  border-radius: 5px;
  padding: 10px;
  margin: 10px 0;
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;

  .card-content{
    flex-grow: 1;
  }
`;

const DeleteBtn = styled.button`
    appearance: none;
    -webkit-appearance: none;
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    border: none;
    &:before{
        content: "✕";
        color: #49475B;
        font-size: 14px;
    }
    &.deleting{
        &:before{
            display: none;
        }
    }
`;

interface ToggleableCardWrapperProps {
  handleDelete: () => void;
  className?: string;
  isDeleting?: boolean;
}

export const ToggleableCardWrapper = (props: React.PropsWithChildren<ToggleableCardWrapperProps>) => {
  return (
    <CardToggleWrapper className={classnames(
      "displayFlex justifyBetween alignStart", props.className
    )}>
      <div className="card-content">
        {props.children}
      </div>
      <div className="card-delete-btn">
        <DeleteBtn
          className={classnames({ "deleting": props?.isDeleting })}
          onClick={props.handleDelete}
        >
          {props?.isDeleting && (
            <span style={{ zoom: '0.225' }}>
              <Loading />
            </span>
          )}
        </DeleteBtn>
      </div>
    </CardToggleWrapper>
  )
}